module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/afore36-472bb508fa30f06c3b3771b7c80f4414.jpg";